module.exports = __webpack_public_path__ + "static/media/flag-filled.b042d9d8.svg";